import * as React from 'react'

import FieldModal from 'modules/custom_resources/components/CustomFields/FieldModal'
import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type Field from 'modules/custom_resources/store/models/customResources/Field'

type FieldModalProps = React.ComponentProps<typeof FieldModal>

interface Props {
  allowedFieldTypes?: string[]
  allowPermissions?: boolean
  field: Field | CustomField | null | undefined
  paramsProcessor: Record<string, any>
  onClose: () => void
  onSubmit: FieldModalProps['onSubmit']
  showAllowedFieldTypes?: boolean
  showRequired?: boolean
}

const EditModal = ({
  showAllowedFieldTypes,
  showRequired,
  allowedFieldTypes,
  allowPermissions,
  field,
  onClose,
  onSubmit,
  paramsProcessor,
}: Props) => {
  return (
    <FieldModal
      modalIllustration={paramsProcessor.get('modalIllustration')}
      modalTitle={paramsProcessor.get('modalTitle', field)}
      modalDescription={paramsProcessor.get('modalDescription', field)}
      modalPlaceholder={paramsProcessor.get('modalPlaceholder')}
      modalLabel={paramsProcessor.get('modalLabel')}
      modalButton={paramsProcessor.get('modalButtonUpdate')}
      modalAlert={paramsProcessor.get('modalAlert')}
      allowedFieldTypes={allowedFieldTypes}
      allowPermissions={allowPermissions}
      showAllowedFieldTypes={showAllowedFieldTypes}
      showRequired={showRequired}
      field={field}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}

export default EditModal
